// extracted by mini-css-extract-plugin
export default {"optionButton":"style_optionButton__vcREC"};